import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_PURCHASEREQUESTS } from "../../../../utils/constants";
import documentTemplateService from "../../../../services/general/documentTemplateService";

const usePRSchema = () =>
  useQuery<string[], Error>({
    queryKey: [`${CACHE_KEY_PURCHASEREQUESTS}Schema`],
    queryFn: () => documentTemplateService.GetSchema("PurchaseRequestModule"),
    initialData: [],
  });

export default usePRSchema;
